
import ProductsSearch from '@/graphql/queries/products/ProductsSearch'

export default {
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    categoryId: {
      type: String,
      default: null
    },
    variables: {
      type: Object,
      default: null
    },
    namespace: {
      type: String,
      default: 'products'
    },
    sorting: {
      type: String,
      default: 'sortOrder_ASC'
    }
  },
  data() {
    return {
      category: null
    }
  },
  computed: {
    excludeCategory() {
      return this.category ? this.category.name : null
    },
    titleAttrs() {
      const options = {
        fontSize: '3xl'
      }

      if (this.title) {
        options.html = this.title
      }

      return options
    },
    query() {
      return ProductsSearch
    },
    list() {
      return {
        itemHeight: 394,
        columns: { all: 1, sm: 2, md: 3, lg: 4 },
        gap: 'md',
        ratio: 0.1
      }
    },
    pagination() {
      return {
        prevText: this.$t('previous'),
        nextText: this.$t('next'),
        paddingX: { xl: 'sm' },
        textAlign: 'center',
        layout: 'prev, pager, ->, next'
      }
    },
    filters() {
      return {
        namespace: this.namespace,
        actions: {
          toggle: {
            position: 'bar'
          },
          clear: {
            position: 'bar'
          }
        },
        inputs: {
          search: {
            title: 'filters.search',
            type: 'search'
          },
          categories: {
            title: this.$t('filters.categories'),
            type: 'checkbox',
            defaultValue: this.category && [this.category.name]
          },
          sorting: {
            title: 'selectSorting',
            type: 'sorting',
            position: 'bar',
            defaultValue: this.sorting
          },
          category: {
            type: 'select',
            position: 'bar',
            $agg: 'categories',
            defaultValue: this.category && this.category.name,
            $attrs: {
              label: 'filters.type',
              allItemsLabel: 'filters.allCategories'
            }
          },
          price: {
            title: 'filters.priceRange',
            type: 'range'
          }
        }
      }
    }
  },
  methods: {
    onFetchCategory(data) {
      if (data) {
        this.category = data
      }
    }
  }
}
